// File: client/src/services/mlApi.js
import axios from 'axios';

const mlApi = axios.create({
  baseURL: process.env.REACT_APP_ML_API_URL || 'http://localhost:8000',
});

export default mlApi;